import React from 'react'
import { categoriesWithIcons } from 'keys/categories'
import { AssessmentCategoryCellStyles } from './Style'
import { SvgIcon } from '@mui/material'

const RateAndAccuracyValueCell = (props) => {
    const { row } = props
    const { original } = row
    const { reading_assessment_category_label, reading_assessment_category_name } = original

    const assessmentCategoryItem = categoriesWithIcons?.[reading_assessment_category_name] || categoriesWithIcons?.["default"]

    return (
        !reading_assessment_category_label ||
        <AssessmentCategoryCellStyles>
            <SvgIcon component={assessmentCategoryItem.icon} inheritViewBox />
            {reading_assessment_category_label}
        </AssessmentCategoryCellStyles>
    )
}

export default RateAndAccuracyValueCell